import React, { useState } from "react";
import { createCustomer } from "../../services";

const CustomerCreate = (props) => {
  const [firstName, setFirstName] = useState(""); // Firstname of customer contact
  const [lastName, setLastName] = useState(""); // Lastname of customer contact
  const [name, setName] = useState(""); // Customer name
  const [address, setAddress] = useState(""); // Customer Address
  const [city, setCity] = useState(""); // Customer city
  const [postal, setPostal] = useState(""); // Customer postal/zipcode
  const [phone, setPhone] = useState(""); // Customer phone
  const [email, setEmail] = useState(""); // Customer email
  const [VSE, setVSE] = useState(0); // Standard dispensing unit of customer in grams

  const submitCustomer = () => {
    createCustomer(firstName + " " + lastName, name, address, city, postal, email, phone).then((res) => {
      props.setCustomerId(res.customer_id);
      props.next();
    });
  };

  return (
    <div className="form__container__content">
      <div className="form__container__content__category">
        <span>Zorginstelling</span>
      </div>
      <div className="form__fields">
        <div className="form__fields__field">
          <span className="form__fields__field__label">Klantnaam</span>
          <input
            required="true"
            onChange={(e) => setName(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Adres</span>
          <input
            required="true"
            onChange={(e) => setAddress(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Postcode</span>
          <input
            required="true"
            onChange={(e) => setPostal(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Plaats</span>
          <input
            required="true"
            onChange={(e) => setCity(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
      </div>
      <div className="form__container__content__category">
        <span>Contactgegevens</span>
      </div>
      <div className="form__fields">
        <div className="form__fields__field">
          <span className="form__fields__field__label">
            Voornaam
          </span>
          <input
            required="true"
            onChange={(e) => setFirstName(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">
            Achternaam
          </span>
          <input
            required="true"
            onChange={(e) => setLastName(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">
            E-mailadres
          </span>
          <input
            required="true"
            onChange={(e) => setEmail(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">
            Telefoonnummer
          </span>
          <input
            required="true"
            onChange={(e) => setPhone(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
      </div>
      <button
        className="form__container__content__button"
        onClick={() => submitCustomer()}
      >
        OPSLAAN <i className="fas fa-arrow-right"></i>
      </button>
    </div>
  );
};

export default CustomerCreate;
